import { ApolloClient, InMemoryCache } from "@apollo/client";

const token = process.env.REACT_APP_FLOWGRAPH_API_KEY;
const flowGraphURL = "https://query.flowgraph.co/?token=" + token;

export const client = new ApolloClient({
  uri: flowGraphURL,
  cache: new InMemoryCache(),
});
